<template>
  <div class="ui left aligned container">
    <vuetable ref="vuetable"
              api-url="/xunyee/list"
              :fields="fields"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    <div>
      <br/>
    </div>
    <div class="ui hidden divider"></div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style>
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'

  export default {
    name: 'Xunyee',
    components: {
      Vuetable,
      VuetablePagination,
      'v-chart': ECharts
    },
    data () {
      return {
        fields: [
          {name: 'date', title: '日期'},
          {name: 'checkinRank', title: '签到排名'},
          {name: 'checkinCount', title: '签到数量'},
          {name: 'indexRank', title: '指数排名'},
          {name: 'indexScore', title: '指数'},
        ],
        page: 0,
        options: null,
        sortOrder: [
          {
            field: 'date',
            direction: 'desc'
          }
        ]
      }
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        if (page === 'prev') {
          this.page--
        } else if (page === 'next') {
          this.page++
        } else {
          this.page = parseInt(page)
        }
        this.$refs.vuetable.changePage(page)
      }
    }
  }
</script>
